import React, { useState, useEffect } from 'react'
import Login from './component/login';
import { Get_User_Type } from '../../Services/ApiCalling'
import { ToastContainer } from "react-toastify";

const LoginView = () => {
    

    return (
        <>
            <Login />
            < ToastContainer />
        </>
    )
}

export default LoginView